/* eslint-disable consistent-return */
/* eslint-disable object-curly-newline */
import React from 'react';
import * as _ from 'lodash';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/styles';
import { withNamespaces } from 'react-i18next';

const footer = require('../../../../public/hb_powered_by_int.png');

const styles = () => ({
  container: {
    backgroundColor: 'white',
    width: '21cm',
    height: '29.7cm',
    overflow: 'hidden',
  },
  metadataTitle: {
    width: '40%',
    fontSize: 14,
  },
  metadataValue: {
    width: '60%',
    fontSize: 14,
  },
  tdHeader: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 8,
  },
  td: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 12,
    padding: 8,
  },
  tdTotal: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    fontSize: 12,
    padding: 8,
  },
  metadataSpace: {
    height: 10,
  },
});

@withNamespaces('pdf', { wait: true })
@withStyles(styles, { index: 1 })
class TimeSpentReportComponent extends React.Component {
  KEY = 'timeSpentReport';

  constructor(props) {
    super(props);
    const sessionLanguage = _.get(props, ['location', 'query', 'session-language']);
    if (sessionLanguage) {
      props.i18n.changeLanguage(sessionLanguage);
    }
  }

  _formatDateTime = (value, timezone) => {
    const { t } = this.props;
    const parsed = moment(value);
    if (!parsed.isValid()) {
      return t(`${this.KEY}.table.notAvailable`);
    }
    return parsed.tz(timezone).format('DD MMM YYYY, HH:mm');
  }

  render = () => {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <div style={{ padding: 20 }}>
          {this._header()}
          <div style={{ height: 20 }} />
          {this._table()}
          {this._footer()}
        </div>
      </div>
    );
  }

  _header = () => {
    const { reportMetaData, classes, t } = this.props;
    if (!reportMetaData) return;

    return (
      <div style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={reportMetaData.hospitalLogo} style={{ width: 110, height: 110, marginTop: 12, marginBottom: 12 }} />
        </div>
        <div style={{ width: '100%', textAlign: 'center', fontSize: 20, fontWeight: 'bold', fontFamily: 'Roboto', marginTop: 12, marginBottom: 12 }}>
          {t(`${this.KEY}.title`)}
        </div>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.patientName`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.patient}</td>
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.patientIdAndNo`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.idType} {reportMetaData.idNo}</td>
            </tr>
            <tr>
              <td className={classes.metadataSpace} />
              <td className={classes.metadataSpace} />
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.providerName`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.provider}</td>
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.hospitalClinicName`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.hospital}</td>
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.programName`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.program}</td>
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.periodOfReportDate`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.periodReport}</td>
            </tr>
            <tr>
              <td className={classes.metadataSpace} />
              <td className={classes.metadataSpace} />
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.dateAndTimeOfReport`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.dateOfReport}</td>
            </tr>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.downloadedBy`)}</td>
              <td className={classes.metadataValue}>: {reportMetaData.downloadedBy}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  _table = () => {
    const { notes, classes, t } = this.props;
    return (
      <div style={{ height: '609px' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th className={classes.tdHeader}>{t(`${this.KEY}.table.startDateTime`)}</th>
              <th className={classes.tdHeader}>{t(`${this.KEY}.table.endDateTime`)}</th>
              <th className={classes.tdHeader}>{t(`${this.KEY}.table.providerName`)}</th>
              <th className={classes.tdHeader}>{t(`${this.KEY}.table.category`)}</th>
              <th className={classes.tdHeader}>{t(`${this.KEY}.table.duration`)}</th>
            </tr>
          </thead>
          <tbody>
            {notes.map((n) => this._tableCell(n))}
            {this._totalCell()}
          </tbody>
        </table>
      </div>
    );
  }

  _totalCell = () => {
    const { classes, totalHours, totalMinutes, page, totalPages, t } = this.props;
    if (+page !== +totalPages) {
      return;
    }

    return (
      <tr>
        <td className={classes.td} style={{ borderRight: 'none' }} />
        <td className={classes.td} style={{ borderLeft: 'none', borderRight: 'none' }} />
        <td className={classes.td} style={{ borderLeft: 'none', borderRight: 'none' }} />
        <td className={classes.tdTotal} style={{ borderRight: 'none', borderLeft: 'none' }}>
          {t(`${this.KEY}.table.totalTimeSpent`)}
        </td>
        <td className={classes.tdTotal} style={{ borderLeft: 'none' }}>
          {totalHours ? `${totalHours} ${t(`${this.KEY}.units.hrs`)}` : ''}{' '}
          {totalMinutes ? `${totalMinutes} ${t(`${this.KEY}.units.mins`)}` : ''}
        </td>
      </tr>
    );
  }

  _tableCell = (data) => {
    const { classes, reportMetaData, t } = this.props;
    return (
      <tr key={`${data.startTime}-${data.endTime}-${data.category}`}>
        <td className={classes.td}>{this._formatDateTime(data.startTime, reportMetaData.timezone)}</td>
        <td className={classes.td}>{this._formatDateTime(data.endTime, reportMetaData.timezone)}</td>
        <td className={classes.td}>{reportMetaData.provider}</td>
        <td className={classes.td}>{data.category}</td>
        <td className={classes.td}>{data.duration || t(`${this.KEY}.table.notAvailable`)}</td>
      </tr>
    );
  }

  _footer = () => {
    const { page, totalPages, t } = this.props;
    return (
      <div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <img src={footer} style={{ width: '50%', float: 'right', marginRight: '-30px' }} />
          </div>
          <div style={{ flex: 1 }}>
            <span style={{ float: 'right', fontSize: 12 }}>
              {t(`${this.KEY}.footer.pageOf`, { page, totalPages })}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default TimeSpentReportComponent;
